export default __webpack_public_path__ + "static/media/boy-with-phone-mobile.99b6a39c.png";